import { useEffect, useState } from "react";
import { fmtMT } from "@/lib/mountainTime";
import { analytics } from "@/lib/fbLabApi";

const M = ["comments_total", "reactions_total", "shares_total", "seen_by", "video_views"];
const cell = (m) => (m?.available ? Number(m.value).toLocaleString() : "Not Available");

export function AnalyticsCard({ refreshKey }) {
  const [rows, setRows] = useState(null);
  useEffect(() => { analytics().then(setRows).catch(() => setRows([])); }, [refreshKey]);
  return (
    <section data-testid="lab-analytics" className="bg-white border border-stone-200 rounded-xl p-4 space-y-2 overflow-x-auto">
      <h2 className="font-semibold">Compare ads</h2>
      <p className="text-xs text-stone-600">Only numbers Facebook actually shows on the page. “Seen by” is the group-member count Facebook shows admins — not views or impressions. Video views appear only on video posts.</p>
      {!rows ? <p className="text-sm text-stone-500">Loading…</p> : !rows.length ? <p className="text-sm text-stone-500">No posts yet.</p> : (
        <table className="text-xs w-full">
          <thead><tr className="text-left text-stone-500"><th>Horse</th><th>Comments (FB)</th><th>Reactions</th><th>Shares</th><th>Seen by</th><th>Video views</th><th>Captured</th><th>Possible bids</th><th>Needs review</th><th>Validated high</th><th>Last synced</th></tr></thead>
          <tbody>{rows.map((r) => (
            <tr key={r.post_id} data-testid={`lab-analytics-${r.post_id}`} className="border-t">
              <td className="py-1 pr-2 font-semibold">{r.horse_name}</td>{M.map((k) => <td key={k} className="pr-2">{cell(r.metrics[k])}</td>)}
              <td className="pr-2">{r.comments_captured}</td><td className="pr-2">{r.potential_bids}</td><td className="pr-2">{r.needs_review}</td>
              <td className="pr-2">{r.validated_high ? `$${r.validated_high.amount.toLocaleString()} ${r.validated_high.currency}` : "—"}</td>
              <td>{r.last_synced_at ? fmtMT(r.last_synced_at) : "never"}</td>
            </tr>))}</tbody>
        </table>)}
    </section>
  );
}
